import { widgets } from './widgets.reducer';

export default {
  widgets
}